// V1's greetings, word for word — صفوفي and the welcome intro.
export function greeting(h = new Date().getHours()) {
  if (h >= 5 && h < 12) return 'صباح الإشراق على قلوبٍ مطمئنة بذكر الله';
  if (h >= 12 && h < 14) return 'اسعد الله اوقاتك';
  if (h >= 14 && h < 18) return 'طاب مساؤك بالسكينة والأنس';
  if (h >= 18 && h < 21) return 'مساءٌ تُرفع فيه الأكفّ بالدعاء فيُستجاب';
  return 'أحلاماً سعيدة';
}

export const greetEmoji = (h = new Date().getHours()) => (h >= 5 && h < 12 ? '☀️' : h < 18 ? '🌤️' : '🌙');
